// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("./Figtree-VariableFont_wght.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("./RobotoMono-VariableFont_wght.ttf", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:root {
  --body-background: white;
  --popup-background: rgb(247, 247, 247);
  --text: #535353;
  --text-bold: #252525;
  --popup-container-background: rgba(0, 0, 0, 0.5);
  --text-button: white;
  --menu-list-button-background: #fafafa;
  --border: #e6e6e6;
  --secondary-button-background: #f0f0f0c9;
  --text-input-background: var(--secondary-button-background);
  --primary: #007bff;
  --default-box-shadow: rgba(0, 0, 0, 0.02) 0px 1px 3px 0px, rgba(27, 31, 35, 0.15) 0px 0px 0px 1px;
}

@font-face {
  font-family: "Figtree";
  src: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
}

@font-face {
  font-family: "Roboto Mono";
  src: url(${___CSS_LOADER_URL_REPLACEMENT_1___});
}

html {
  font-size: 16px;
}

main section {
  display: flex;
  flex-direction: column;
  gap: 20px;
}

html, #root {
  width: 100%;
  height: 100%;
  overflow: hidden;
}

#root {
  display: flex;
  flex-direction: column;
}

body {
  margin: 0;
  height: 100%;
  background-color: var(--body-background);
  transition: 0.3s;
}

p, li {
  line-height: 1.5;
  color: var(--text);
}

.query-input {
  font-family: "Roboto Mono", monospace;
}

h1, button, p, th, td, a, section, input, textarea {
  font-family: "Figtree", sans-serif;
}

a {
  text-decoration: none;
  color: var(--primary)
}

h1, h2, h3, h4 {
  margin: 0;
}

h1 {
  font-size: 2rem;
}

h1, h2, p {
  margin: 0;
}

code {
  padding: 5px;
  border-radius: 5px;
  border: 1px solid var(--border);
}

.column-section {
  display: flex;
  flex-direction: column;
  gap: 15px;
}

.toolbar {
  border-bottom: 1px solid var(--border);
  width: 100%;
  display: flex;
  box-sizing: border-box;
  flex-shrink: 0;
  padding: 10px 15px;
  transition: 0.3s;
  gap: 10px;
}

button, input[type="submit"], .button {
  border: none;
  padding: 10px 15px;
  border-radius: 25px;
  cursor: pointer;
  transition: 0.1s;
  display: flex;
  align-items: center;
  gap: 10px;
  background-color: var(--secondary-button-background);
  color: var(--text);
  justify-content: center;
}

button[disabled], input[disabled], textarea[disabled] {
  cursor: not-allowed;
  opacity: 0.5;
}

button:hover, .button:hover {
  filter: brightness(0.9);
}

button:hover:active, .button:hover:active {
  transform: scale(0.95);
}

button.primary-button, input[type="submit"].primary-button {
  background-color: var(--primary);
  color: var(--text-button);
}

.primary-button > svg {
  fill: var(--text-button);
} 

button.destructive-button, input[type="submit"].destructive-button {
  color: rgb(255, 85, 85);
}

button.destructive-button-filled, input[type="submit"].destructive-button-filled {
  background-color: rgb(255, 85, 85);
  color: var(--text-button);
}

.button-list {
  list-style: none;
  padding: 0;
  margin: 0;
  display: flex;
  flex-direction: row;
  gap: 15px;
  flex-wrap: wrap;
}

form {
  display: flex;
  flex-direction: column;
  gap: 15px;
}

form > section, .input-section {
  display: flex;
  flex-direction: column;
  gap: 15px;
}

input[type="text"], input[type="password"], textarea {
  border-radius: 5px;
  padding: 10px 15px;
  border: none;
  font-size: 1rem;
  background-color: var(--text-input-background);
  color: var(--text);
  box-sizing: border-box;
}

textarea {
  resize: vertical;
}

button {
  font-size: 1rem;
}

ul {
  margin: 0;
  display: flex;
  flex-direction: column;
  gap: 15px;
}

main {
  display: flex;
  padding: 15px;
  gap: 30px;
  flex-direction: column;
  box-sizing: border-box;
  margin: 0 auto;
  flex-grow: 1;
  overflow-y: auto;
  width: 100%;
  flex-basis: 0;
}

#scroll-container {
  overflow-y: auto;
}

h1, h2, h3, h4, h5, h6, p, li, label, section {
  color: var(--text);
}

#content {
  display: flex;
  box-sizing: border-box;
  transition: 0.3s;
  flex-grow: 1;
}

#main-container {
  width: 100%;
  display: flex;
  flex-direction: column;
  flex-grow: 1;
}

.heading-with-button {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

label {
  font-weight: bold;
  color: var(--text);
}

button svg {
  fill: var(--text);
  width: 20px;
  height: 20px;
}

.horizontal-row {
  display: flex;
  gap: 15px;
}

.table-container {
  overflow-x: auto;
  width: 100%;
}

table {
  text-align: left;
  border-spacing: 0;
  border-radius: 5px;
  width: max-content;
  min-width: 100%;
  table-layout: fixed;
}

table th, table td {
  padding: 10px;
}

table button {
  padding: 0 15px;
  height: 30px;
}

table .icon-button {
  width: 30px;
  height: 30px;
  padding: 0;
}

.checkbox-colgroup {
  width: 52px;
}

.checkbox-cell > section {
  display: flex;
  align-items: center;
  justify-content: center;
}

table tr {
  height: 52px;
}

table th {
  border-top: 1px solid var(--border);
}

table th:first-of-type {
  border-top-left-radius: 5px;
}

.icon-button {
  border-radius: 100%;
  width: 40px;
  height: 40px;
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 0;
}

.item-description {
  font-size: 0.8rem;
}

.pagination-dropdown-container {
  display: flex;
  align-items: center;
  gap: 5px;
}

.account {
  display: flex;
  flex-direction: column;
  gap: 5px;
  padding: 15px;
  border-radius: 5px;
  box-shadow: rgba(0, 0, 0, 0.02) 0px 1px 3px 0px, rgba(27, 31, 35, 0.15) 0px 0px 0px 1px;
}

.account-type {
  font-size: 0.9rem;
}

table th:last-of-type {
  border-top-right-radius: 5px;
}

table tbody tr:last-of-type td:first-of-type {
  border-bottom-left-radius: 5px;
}

table tbody tr:last-of-type td:last-of-type {
  border-bottom-right-radius: 5px;
}

table th:first-of-type, table td:first-of-type {
  border-left: 1px solid var(--border);
}

table th, table td {
  border-bottom: 1px solid var(--border);
  border-right: 1px solid var(--border);
  height: 52px;
  box-sizing: border-box;
}

main > h1 {
  display: none;
}

@media screen and (min-width: 400px) {
  
  main > h1 {
    display: block;
  }

  main {
    padding: 30px;
  }

  #content.sidebar-open {
    width: 100%;
  }

}

@media (prefers-color-scheme: dark) {
  
  :root {
    --text: #c5c5c5;
    --text-bold: #eeeeee;
    --body-background: rgb(8, 8, 8);
    --popup-background: #121214;
    --menu-list-button-background: rgb(18, 18, 20);
    --border: rgb(27, 27, 27);
    --secondary-button-background: rgb(18, 18, 20);
  }

}

@media print {

  main > h1 {
    display: block;
  }

  #main-container {
    overflow-y: auto;
  }

}`, "",{"version":3,"sources":["webpack://./src/Router/App/global.css"],"names":[],"mappings":"AAAA;EACE,wBAAwB;EACxB,sCAAsC;EACtC,eAAe;EACf,oBAAoB;EACpB,gDAAgD;EAChD,oBAAoB;EACpB,sCAAsC;EACtC,iBAAiB;EACjB,wCAAwC;EACxC,2DAA2D;EAC3D,kBAAkB;EAClB,iGAAiG;AACnG;;AAEA;EACE,sBAAsB;EACtB,4CAAyC;AAC3C;;AAEA;EACE,0BAA0B;EAC1B,4CAA4C;AAC9C;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,SAAS;EACT,YAAY;EACZ,wCAAwC;EACxC,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,qCAAqC;AACvC;;AAEA;EACE,kCAAkC;AACpC;;AAEA;EACE,qBAAqB;EACrB;AACF;;AAEA;EACE,SAAS;AACX;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,SAAS;AACX;;AAEA;EACE,YAAY;EACZ,kBAAkB;EAClB,+BAA+B;AACjC;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,sCAAsC;EACtC,WAAW;EACX,aAAa;EACb,sBAAsB;EACtB,cAAc;EACd,kBAAkB;EAClB,gBAAgB;EAChB,SAAS;AACX;;AAEA;EACE,YAAY;EACZ,kBAAkB;EAClB,mBAAmB;EACnB,eAAe;EACf,gBAAgB;EAChB,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,oDAAoD;EACpD,kBAAkB;EAClB,uBAAuB;AACzB;;AAEA;EACE,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,gCAAgC;EAChC,yBAAyB;AAC3B;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,kCAAkC;EAClC,yBAAyB;AAC3B;;AAEA;EACE,gBAAgB;EAChB,UAAU;EACV,SAAS;EACT,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,kBAAkB;EAClB,kBAAkB;EAClB,YAAY;EACZ,eAAe;EACf,8CAA8C;EAC9C,kBAAkB;EAClB,sBAAsB;AACxB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,SAAS;EACT,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,aAAa;EACb,SAAS;EACT,sBAAsB;EACtB,sBAAsB;EACtB,cAAc;EACd,YAAY;EACZ,gBAAgB;EAChB,WAAW;EACX,aAAa;AACf;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,gBAAgB;EAChB,YAAY;AACd;;AAEA;EACE,WAAW;EACX,aAAa;EACb,sBAAsB;EACtB,YAAY;AACd;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,iBAAiB;EACjB,WAAW;EACX,YAAY;AACd;;AAEA;EACE,aAAa;EACb,SAAS;AACX;;AAEA;EACE,gBAAgB;EAChB,WAAW;AACb;;AAEA;EACE,gBAAgB;EAChB,iBAAiB;EACjB,kBAAkB;EAClB,kBAAkB;EAClB,eAAe;EACf,mBAAmB;AACrB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,eAAe;EACf,YAAY;AACd;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,UAAU;AACZ;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,mCAAmC;AACrC;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,mBAAmB;EACnB,WAAW;EACX,YAAY;EACZ,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,UAAU;AACZ;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,aAAa;EACb,kBAAkB;EAClB,uFAAuF;AACzF;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,4BAA4B;AAC9B;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE,+BAA+B;AACjC;;AAEA;EACE,oCAAoC;AACtC;;AAEA;EACE,sCAAsC;EACtC,qCAAqC;EACrC,YAAY;EACZ,sBAAsB;AACxB;;AAEA;EACE,aAAa;AACf;;AAEA;;EAEE;IACE,cAAc;EAChB;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,WAAW;EACb;;AAEF;;AAEA;;EAEE;IACE,eAAe;IACf,oBAAoB;IACpB,+BAA+B;IAC/B,2BAA2B;IAC3B,8CAA8C;IAC9C,yBAAyB;IACzB,8CAA8C;EAChD;;AAEF;;AAEA;;EAEE;IACE,cAAc;EAChB;;EAEA;IACE,gBAAgB;EAClB;;AAEF","sourcesContent":[":root {\r\n  --body-background: white;\r\n  --popup-background: rgb(247, 247, 247);\r\n  --text: #535353;\r\n  --text-bold: #252525;\r\n  --popup-container-background: rgba(0, 0, 0, 0.5);\r\n  --text-button: white;\r\n  --menu-list-button-background: #fafafa;\r\n  --border: #e6e6e6;\r\n  --secondary-button-background: #f0f0f0c9;\r\n  --text-input-background: var(--secondary-button-background);\r\n  --primary: #007bff;\r\n  --default-box-shadow: rgba(0, 0, 0, 0.02) 0px 1px 3px 0px, rgba(27, 31, 35, 0.15) 0px 0px 0px 1px;\r\n}\r\n\r\n@font-face {\r\n  font-family: \"Figtree\";\r\n  src: url(./Figtree-VariableFont_wght.ttf);\r\n}\r\n\r\n@font-face {\r\n  font-family: \"Roboto Mono\";\r\n  src: url(./RobotoMono-VariableFont_wght.ttf);\r\n}\r\n\r\nhtml {\r\n  font-size: 16px;\r\n}\r\n\r\nmain section {\r\n  display: flex;\r\n  flex-direction: column;\r\n  gap: 20px;\r\n}\r\n\r\nhtml, #root {\r\n  width: 100%;\r\n  height: 100%;\r\n  overflow: hidden;\r\n}\r\n\r\n#root {\r\n  display: flex;\r\n  flex-direction: column;\r\n}\r\n\r\nbody {\r\n  margin: 0;\r\n  height: 100%;\r\n  background-color: var(--body-background);\r\n  transition: 0.3s;\r\n}\r\n\r\np, li {\r\n  line-height: 1.5;\r\n  color: var(--text);\r\n}\r\n\r\n.query-input {\r\n  font-family: \"Roboto Mono\", monospace;\r\n}\r\n\r\nh1, button, p, th, td, a, section, input, textarea {\r\n  font-family: \"Figtree\", sans-serif;\r\n}\r\n\r\na {\r\n  text-decoration: none;\r\n  color: var(--primary)\r\n}\r\n\r\nh1, h2, h3, h4 {\r\n  margin: 0;\r\n}\r\n\r\nh1 {\r\n  font-size: 2rem;\r\n}\r\n\r\nh1, h2, p {\r\n  margin: 0;\r\n}\r\n\r\ncode {\r\n  padding: 5px;\r\n  border-radius: 5px;\r\n  border: 1px solid var(--border);\r\n}\r\n\r\n.column-section {\r\n  display: flex;\r\n  flex-direction: column;\r\n  gap: 15px;\r\n}\r\n\r\n.toolbar {\r\n  border-bottom: 1px solid var(--border);\r\n  width: 100%;\r\n  display: flex;\r\n  box-sizing: border-box;\r\n  flex-shrink: 0;\r\n  padding: 10px 15px;\r\n  transition: 0.3s;\r\n  gap: 10px;\r\n}\r\n\r\nbutton, input[type=\"submit\"], .button {\r\n  border: none;\r\n  padding: 10px 15px;\r\n  border-radius: 25px;\r\n  cursor: pointer;\r\n  transition: 0.1s;\r\n  display: flex;\r\n  align-items: center;\r\n  gap: 10px;\r\n  background-color: var(--secondary-button-background);\r\n  color: var(--text);\r\n  justify-content: center;\r\n}\r\n\r\nbutton[disabled], input[disabled], textarea[disabled] {\r\n  cursor: not-allowed;\r\n  opacity: 0.5;\r\n}\r\n\r\nbutton:hover, .button:hover {\r\n  filter: brightness(0.9);\r\n}\r\n\r\nbutton:hover:active, .button:hover:active {\r\n  transform: scale(0.95);\r\n}\r\n\r\nbutton.primary-button, input[type=\"submit\"].primary-button {\r\n  background-color: var(--primary);\r\n  color: var(--text-button);\r\n}\r\n\r\n.primary-button > svg {\r\n  fill: var(--text-button);\r\n} \r\n\r\nbutton.destructive-button, input[type=\"submit\"].destructive-button {\r\n  color: rgb(255, 85, 85);\r\n}\r\n\r\nbutton.destructive-button-filled, input[type=\"submit\"].destructive-button-filled {\r\n  background-color: rgb(255, 85, 85);\r\n  color: var(--text-button);\r\n}\r\n\r\n.button-list {\r\n  list-style: none;\r\n  padding: 0;\r\n  margin: 0;\r\n  display: flex;\r\n  flex-direction: row;\r\n  gap: 15px;\r\n  flex-wrap: wrap;\r\n}\r\n\r\nform {\r\n  display: flex;\r\n  flex-direction: column;\r\n  gap: 15px;\r\n}\r\n\r\nform > section, .input-section {\r\n  display: flex;\r\n  flex-direction: column;\r\n  gap: 15px;\r\n}\r\n\r\ninput[type=\"text\"], input[type=\"password\"], textarea {\r\n  border-radius: 5px;\r\n  padding: 10px 15px;\r\n  border: none;\r\n  font-size: 1rem;\r\n  background-color: var(--text-input-background);\r\n  color: var(--text);\r\n  box-sizing: border-box;\r\n}\r\n\r\ntextarea {\r\n  resize: vertical;\r\n}\r\n\r\nbutton {\r\n  font-size: 1rem;\r\n}\r\n\r\nul {\r\n  margin: 0;\r\n  display: flex;\r\n  flex-direction: column;\r\n  gap: 15px;\r\n}\r\n\r\nmain {\r\n  display: flex;\r\n  padding: 15px;\r\n  gap: 30px;\r\n  flex-direction: column;\r\n  box-sizing: border-box;\r\n  margin: 0 auto;\r\n  flex-grow: 1;\r\n  overflow-y: auto;\r\n  width: 100%;\r\n  flex-basis: 0;\r\n}\r\n\r\n#scroll-container {\r\n  overflow-y: auto;\r\n}\r\n\r\nh1, h2, h3, h4, h5, h6, p, li, label, section {\r\n  color: var(--text);\r\n}\r\n\r\n#content {\r\n  display: flex;\r\n  box-sizing: border-box;\r\n  transition: 0.3s;\r\n  flex-grow: 1;\r\n}\r\n\r\n#main-container {\r\n  width: 100%;\r\n  display: flex;\r\n  flex-direction: column;\r\n  flex-grow: 1;\r\n}\r\n\r\n.heading-with-button {\r\n  display: flex;\r\n  justify-content: space-between;\r\n  align-items: center;\r\n}\r\n\r\nlabel {\r\n  font-weight: bold;\r\n  color: var(--text);\r\n}\r\n\r\nbutton svg {\r\n  fill: var(--text);\r\n  width: 20px;\r\n  height: 20px;\r\n}\r\n\r\n.horizontal-row {\r\n  display: flex;\r\n  gap: 15px;\r\n}\r\n\r\n.table-container {\r\n  overflow-x: auto;\r\n  width: 100%;\r\n}\r\n\r\ntable {\r\n  text-align: left;\r\n  border-spacing: 0;\r\n  border-radius: 5px;\r\n  width: max-content;\r\n  min-width: 100%;\r\n  table-layout: fixed;\r\n}\r\n\r\ntable th, table td {\r\n  padding: 10px;\r\n}\r\n\r\ntable button {\r\n  padding: 0 15px;\r\n  height: 30px;\r\n}\r\n\r\ntable .icon-button {\r\n  width: 30px;\r\n  height: 30px;\r\n  padding: 0;\r\n}\r\n\r\n.checkbox-colgroup {\r\n  width: 52px;\r\n}\r\n\r\n.checkbox-cell > section {\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n}\r\n\r\ntable tr {\r\n  height: 52px;\r\n}\r\n\r\ntable th {\r\n  border-top: 1px solid var(--border);\r\n}\r\n\r\ntable th:first-of-type {\r\n  border-top-left-radius: 5px;\r\n}\r\n\r\n.icon-button {\r\n  border-radius: 100%;\r\n  width: 40px;\r\n  height: 40px;\r\n  display: flex;\r\n  justify-content: center;\r\n  align-items: center;\r\n  padding: 0;\r\n}\r\n\r\n.item-description {\r\n  font-size: 0.8rem;\r\n}\r\n\r\n.pagination-dropdown-container {\r\n  display: flex;\r\n  align-items: center;\r\n  gap: 5px;\r\n}\r\n\r\n.account {\r\n  display: flex;\r\n  flex-direction: column;\r\n  gap: 5px;\r\n  padding: 15px;\r\n  border-radius: 5px;\r\n  box-shadow: rgba(0, 0, 0, 0.02) 0px 1px 3px 0px, rgba(27, 31, 35, 0.15) 0px 0px 0px 1px;\r\n}\r\n\r\n.account-type {\r\n  font-size: 0.9rem;\r\n}\r\n\r\ntable th:last-of-type {\r\n  border-top-right-radius: 5px;\r\n}\r\n\r\ntable tbody tr:last-of-type td:first-of-type {\r\n  border-bottom-left-radius: 5px;\r\n}\r\n\r\ntable tbody tr:last-of-type td:last-of-type {\r\n  border-bottom-right-radius: 5px;\r\n}\r\n\r\ntable th:first-of-type, table td:first-of-type {\r\n  border-left: 1px solid var(--border);\r\n}\r\n\r\ntable th, table td {\r\n  border-bottom: 1px solid var(--border);\r\n  border-right: 1px solid var(--border);\r\n  height: 52px;\r\n  box-sizing: border-box;\r\n}\r\n\r\nmain > h1 {\r\n  display: none;\r\n}\r\n\r\n@media screen and (min-width: 400px) {\r\n  \r\n  main > h1 {\r\n    display: block;\r\n  }\r\n\r\n  main {\r\n    padding: 30px;\r\n  }\r\n\r\n  #content.sidebar-open {\r\n    width: 100%;\r\n  }\r\n\r\n}\r\n\r\n@media (prefers-color-scheme: dark) {\r\n  \r\n  :root {\r\n    --text: #c5c5c5;\r\n    --text-bold: #eeeeee;\r\n    --body-background: rgb(8, 8, 8);\r\n    --popup-background: #121214;\r\n    --menu-list-button-background: rgb(18, 18, 20);\r\n    --border: rgb(27, 27, 27);\r\n    --secondary-button-background: rgb(18, 18, 20);\r\n  }\r\n\r\n}\r\n\r\n@media print {\r\n\r\n  main > h1 {\r\n    display: block;\r\n  }\r\n\r\n  #main-container {\r\n    overflow-y: auto;\r\n  }\r\n\r\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
